import {
  Box,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import { getIn, useFormikContext } from 'formik';
import React from 'react';
import { NewCentralFormType } from './types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    switchBase: {
      color: theme.palette.secondary.main,
    },
    checked: {
      '& .MuiSwitch-thumb': { color: theme.palette.primary.main },
    },
    labelLeftChecked: {
      fontWeight: 'bold',
    },
    labelRightChecked: {
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
    notChecked: {
      fontWeight: 'normal',
    },
  })
);

type Props = {
  name: string;
  optionsLabel?: {
    left: string;
    right: string;
  };
};

export const LogicSwitch: React.FC<Props> = ({ name, optionsLabel }) => {
  const { values, handleChange } = useFormikContext<NewCentralFormType>();
  const checked = getIn(values, name);
  const classes = useStyles();
  const right = optionsLabel?.left ?? 'a není';
  const left = optionsLabel?.right ?? 'a současně';

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Typography component="div">
        <Grid component="label" container alignItems="center" spacing={1}>
          <Grid
            item
            className={checked ? classes.notChecked : classes.labelLeftChecked}
          >
            {left}
          </Grid>
          <Grid item>
            <Switch
              checked={checked}
              onChange={handleChange}
              name={name}
              classes={{
                switchBase: classes.switchBase,
                checked: classes.checked,
              }}
            />
          </Grid>
          <Grid
            item
            className={checked ? classes.labelRightChecked : classes.notChecked}
          >
            {right}
          </Grid>
        </Grid>
      </Typography>
    </Box>
  );
};
export default LogicSwitch;
